<script lang="ts" context="module">
	
	export async function openFeedbackForm(url:string) {
		const profile = await firstValueFrom(profile$);
		const formUrl = 'https://docs.google.com/forms/d/e/1FAIpQLScPCo4RVVdocOXCXzWCcDWcZGuGVHyJoy3Qu6wOG5g01Nq5zw/viewform?usp=pp_url'
		const fields = [
			['entry.1064060046', profile && `${encodeURIComponent(profile?.name)} (${profile?.id})` || 'Anonymous'],
			['entry.1934955148', PUBLIC_BUILD_VERSION || 'dev'],
			['entry.547832055', encodeURIComponent(url)],
			['entry.681205593', encodeURIComponent(navigator.userAgent)],
			['entry.1845733395', `${window.innerWidth} x ${window.innerHeight}`],
			['entry.993571419', `${window.screen.width} x ${window.screen.height}` + (window.devicePixelRatio !== 1 ? ` (pixel ratio ${window.devicePixelRatio})` : '')],
		]
		window.open(`${formUrl}&${fields.map(([k, v]) => `${k}=${v}`).join('&')}`, '_blank');
	}
</script>
<script lang="ts">
	import { PUBLIC_BUILD_VERSION } from "$env/static/public";
	import { profile$ } from "$lib/serv/core/auth";
	import { firstValueFrom } from "rxjs";

	export let url: string;

	/**
	 * Taken from https://svelte.dev/repl/48bd3726b74c4329a186838ce645099b?version=3.46.4
	 */

	let isCtrlDown = false;
	let isQDown = false;

	function open() {
		if (isCtrlDown && isQDown) {
			isCtrlDown = false;
			isQDown = false;
			openFeedbackForm(url);
		}
	}

	function onKeyDown(event: KeyboardEvent) {
		if (event.repeat) return;

		switch (event.key) {
			case "Control":
				isCtrlDown = true;
				open();
				break;

			case "q":
				isQDown = true;
				open();
				break;
		}
	}

	function onKeyUp(event: KeyboardEvent) {
		switch (event.key) {
			case "Control":
				isCtrlDown = false;
				break;

			case "q":
				isQDown = false;
				break;
		}
	}


</script>

<svelte:window on:keydown={onKeyDown} on:keyup={onKeyUp} />
